import React, { Component } from 'react';

class PaymentMethodCard extends Component {

    renderExtraInfo = () => {
        const { extra } = this.props;
        if (!extra) return null;

        return (
            <div className="mt-2">

                {extra.reference && (
                    <div className="mb-1">
                        <small className="text-muted font-weight-bold">
                            Ref.
                        </small>
                        <div style={{ fontSize: 13 }}>
                            {extra.reference}
                        </div>
                    </div>
                )}

                {extra.date && (
                    <div className="mb-1">
                        <small className="text-muted font-weight-bold">
                            Fecha
                        </small>
                        <div style={{ fontSize: 13 }}>
                            {extra.date}
                        </div>
                    </div>
                )}

                {Array.isArray(extra.checks) && (
                    <div className="mb-1">
                        <small className="text-muted font-weight-bold">
                            Cheques
                        </small>
                        <ul className="mb-0 pl-3" style={{ fontSize: 13 }}>
                            {extra.checks.map((chk, i) => (
                                <li key={i}>
                                    #{chk.number} – ${chk.amount}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        );
    };

    render() {
        const {
            title,
            account,
            total,
            icon,
            color = '#eabf28'
        } = this.props;

        return (
            <div
                className="card h-100 border-1 shadow-sm"
                style={{
                    borderRadius: 14,
                    transition: 'box-shadow .2s ease, transform .2s ease'
                }}
                onMouseEnter={e => {
                    e.currentTarget.style.boxShadow = '0 10px 26px rgba(0,0,0,.12)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={e => {
                    e.currentTarget.style.boxShadow = '';
                    e.currentTarget.style.transform = '';
                }}
            >
                <div className="card-body p-3">

                    <div className="d-flex justify-content-between align-items-start">

                        {/* BLOQUE PRINCIPAL */}
                        <div>

                            {/* TITULO */}
                            <div
                                className="text-uppercase font-weight-bold text-muted"
                                style={{
                                    fontSize: 12,
                                    letterSpacing: '.5px'
                                }}
                            >
                                {title}
                            </div>

                            {/* TOTAL (PRIORIDAD #1) */}
                            <div
                                className="font-weight-bold"
                                style={{
                                    fontSize: 24,
                                    lineHeight: '28px',
                                    color: '#212529'
                                }}
                            >
                                {total}
                            </div>

                            {/* CUENTA MAYOR */}
                            <div
                                className="text-muted"
                                style={{ fontSize: 13 }}
                            >
                                {account}
                            </div>

                        </div>

                        {/* ICONO */}
                        <div
                            className="d-flex align-items-center justify-content-center"
                            style={{
                                width: 36,
                                height: 36,
                                borderRadius: 10,
                                backgroundColor: '#eabf28'
                            }}
                        >
                            <i
                                className={icon}
                                style={{
                                    fontSize: 16,
                                    color: color
                                }}
                            />
                        </div>

                    </div>

                    {/* INFO EXTRA */}
                    {this.renderExtraInfo()}

                </div>
            </div>
        );
    }
}

export default PaymentMethodCard;
